module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "oak-haven-timber-hayman-0.66c961e6.jpg";